import React from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'
import { Col, Container, Row } from 'react-bootstrap'

import Layout from '@shared-components/layout'
import { pageHeaderLoader } from '@shared/libs/allLoader'

const PollListContent = dynamic(() => import('@shared/components/multiPoll/pollListContent'))
const PageHeader = dynamic(() => import('@shared-components/pageHeader'), { loading: () => pageHeaderLoader() })
// const CurrentSeries = dynamic(() => import('@shared/components/widgets/currentSeries'), { loading: () => pageLoading() })
// const Ads = dynamic(() => import('@shared/components/ads'))

const PollList = ({ seoData, widgetData, pollList }) => {
  return (
    <Layout data={{ oSeo: seoData }}>
      <main className="my-3 my-md-4">
        <Container>
          <Row>
            <Col xs={12}>
              <PageHeader name="Cricket Polls" seoData={seoData} />
              <PollListContent poll={pollList} />
            </Col>
            {/* <Col xl={4} xxl={3} className="d-none d-lg-block common-sidebar">
              <CurrentSeries data={widgetData.currentSeries} />
            </Col> */}
          </Row>
        </Container>
      </main>
    </Layout>
  )
}
export default PollList

PollList.propTypes = {
  seoData: PropTypes.object,
  widgetData: PropTypes.object,
  pollList: PropTypes.array
}

export async function getServerSideProps({ req, res, params, query, resolvedUrl }) {
  const [graphql, articleQuery, utils, widgetQuery, pollQuery] = await Promise.all([
    import('@shared-components/queryGraphql'),
    import('@graphql/article/article.query'),
    import('@shared/utils'),
    import('@graphql/globalwidget/rankings.query'),
    import('@graphql/poll/poll.query')
  ])

  try {
    const [seoData, currentSeries, poll] = await Promise.allSettled([
      graphql.default(articleQuery.GET_ARTICLE_ID, { input: { sSlug: 'cricket-polls' } }),
      graphql.default(widgetQuery.CURRENT_SERIES_LIST),
      graphql.default(pollQuery.LIST_POLL, {
        input: { nLimit: 10, nSkip: 1, aStatus: query?.['ct-tab'] || 'pub', sSearch: query?.['ct-sSearch'] || null }
      })
    ])
    const seo = seoData?.value?.data?.getSeoData
    res.setHeader('Cache-Control', 'public, max-age=900')

    return {
      props: {
        seoData: seo || {},
        pollList: poll.value.data.listPollFront || [],
        widgetData: {
          currentSeries: currentSeries?.value?.data?.getCurrentPopularSeries || []
        }
      }
    }
  } catch (e) {
    res.setHeader('Cache-Control', 'no-cache')
    const status = utils.handleApiError(e, resolvedUrl)
    return status
  }
}
